import {
    PollieRaterContentModels,
    PollieRaterData,
    PollieRaterItem,
} from './PollieRater'

/**
 * Function checks if an item denoted by its ID and ItemType currently exists in the data stored inside pollie-rater.json (passed through by the existingData param).
 * @param existingData
 * Data that currently exists inside the pollie-rater (pollie-rater.json).
 * @param itemType
 * ItemType of the object being checked (asset, politician, electorate and party)
 * @param id
 * ID of the object.
 */
export const checkForExistingItem = (
    existingData: PollieRaterData,
    itemType: PollieRaterContentModels,
    id: string,
): PollieRaterItem | undefined => {
    const { items: existingItems } = existingData

    try {
        const item = existingItems
            ? existingItems.filter((entry) => {
                  return (
                      entry.contentModel === itemType && entry.details.id === id
                  )
              })
            : undefined

        if (item && item.length > 1) {
            throw new Error(`Duplicate of ${itemType} ${id}`)
        }

        return item ? item[0] : undefined
    } catch (e) {
        throw new Error(
            `Error whilst checking if ${itemType} ${id} currently exists in our dataset` +
                JSON.stringify(e),
        )
    }
}
